<template>
  <div class="form-group">
    <label :for="id" class="glass-label">
      {{ label }}
      <span v-if="required" class="visually-hidden">Requis</span>
    </label>
    <select
      :id="id"
      :value="modelValue"
      @input="onInput"
      class="glass-select"
      :class="{
        inactive: !optionIsSelected
      }"
      :required="required"
      :aria-required="required"
      :placeholder="placeholder"
    >
      <option value="" disabled>{{ placeholder }}</option>
      <option v-for="option in options" :key="option.id" :value="option.id">
        {{ option.value }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SelectComponent',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Sélectionnez une option'
    }
  },

  data() {
    return {
      optionIsSelected: false
    }
  },

  methods: {
    onInput(event) {
      this.optionIsSelected = true
      this.$emit('update:modelValue', event.target.value)
    }
  }
}
</script>

<style scoped>
/* Glass select */
.glass-select {
  background: rgba(255, 255, 255, 0.05) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 12px !important;
  color: #ffffff !important;
  padding: 12px 16px !important;
  font-size: var(--font-size-sm) !important; /* 16px - Standard web */
  transition: all 0.3s ease !important;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  width: 100% !important;
  appearance: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  background-image: url("data:image/svg+xml;charset=UTF-8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6,9 12,15 18,9'></polyline></svg>") !important;
  background-repeat: no-repeat !important;
  background-position: right 12px center !important;
  background-size: 16px !important;
}

.glass-select:focus {
  background: rgba(255, 255, 255, 0.08) !important;
  border-color: #6bb4f8 !important;
  box-shadow:
    0 0 0 3px rgba(107, 180, 248, 0.1),
    inset 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  outline: none !important;
}

.glass-select option {
  background: #2a4a6b !important;
  color: #ffffff !important;
  padding: 8px 12px !important;
}

.glass-select.inactive {
  color: rgba(255, 255, 255, 0.4) !important;
}

.glass-select.is-invalid {
  border-color: #dc3545 !important;
  box-shadow:
    0 0 0 3px rgba(220, 53, 69, 0.1),
    inset 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}
</style>
